document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('.contact-form-wrapper form');
  const submitBtn = document.querySelector('.submit-btn');

  if (!form) return;

  form.addEventListener('submit', (event) => {
    const email = document.getElementById('ContactEmail');
    const name = document.getElementById('ContactName');
    const subject = document.getElementById('ContactSubject');
    const message = document.getElementById('ContactMessage');

    let isValid = true;

    if (email && !email.validity.valid) {
      isValid = false;
      email.classList.add('error');
    } else if (email) {
      email.classList.remove('error');
    }

    [name, subject, message].forEach((field) => {
      if (field && !field.value.trim()) {
        isValid = false;
        field.classList.add('error');
      } else if (field) {
        field.classList.remove('error');
      }
    });

    if (!isValid) {
      event.preventDefault();
      return;
    }

    if (submitBtn) {
      submitBtn.textContent = 'Sending...';
      submitBtn.disabled = true;
    }
  });

  const inputs = form.querySelectorAll('.form-input, .form-textarea');
  inputs.forEach((input) => {
    input.addEventListener('input', function () {
      this.classList.remove('error');
    });
  });
});
